
/* eslint-disable */
// @ts-nocheck
// @ts-ignore

import * as srvoption from './srvoption.proto';
import * as im_api_callback from './im_api_callback.proto';
import * as user_common from './user_common.proto';
import * as im_api_message from './im_api_message.proto';
import * as im_system from './im_system.proto';
import * as im_interaction_message from './im_interaction_message.proto';
import * as rolecard_srv from './rolecard_srv.proto';
import * as external_login_common from './external_login_common.proto';
import * as common from './common.proto';
import * as group_minor_comm from './group_minor_comm.proto';
import * as im_message from './salmonim\im_message.proto';


export interface VideoInfo {
  /** 视频下载地址。可通过该 URL 地址直接下载相应视频。 */
  videoUrl: string;
  /** 视频数据大小，单位：字节。 */
  videoSize: string;
  /** 视频时长，单位：秒。 */
  videoSecond: number;
  /** 视频格式，例如 mp4 */
  videoFormat: string;
  /** 视频下载方式标记。目前 VideoDownloadFlag 取值只能为2，表示可通过VideoUrl字段值的 URL 地址直接下载视频 */
  videoDownloadFlag: number;
  /** 视频缩略图下载地址。可通过该 URL 地址直接下载相应视频缩略图。 */
  thumbUrl: string;
  /** 缩略图大小，单位：字节。 */
  thumbSize: string;
  /** 缩略图宽度。 */
  thumbWidth: number;
  /** 缩略图高度。 */
  thumbHeight: number;
  /** 缩略图格式，例如 JPG、BMP 等。 */
  thumbFormat: string;
  /** 视频缩略图下载方式标记。目前 ThumbDownloadFlag 取值只能为2，表示可通过ThumbUrl字段值的 URL 地址直接下载视频缩略图。 */
  thumbDownloadFlag: number;
  /** 视频宽度。 */
  videoWidth: number;
  /** 视频高度。 */
  videoHeight: number;
}

export interface ImageInfo {
  /** 图片类型： 1-原图，2-缩略图。 */
  type: number;
  /** 图片数据大小，单位：字节。 */
  size: number;
  /** 图片宽度。 */
  width: number;
  /** 图片高度。 */
  height: number;
  /** 图片下载地址。 */
  url: string;
  /** 表情图md5 */
  md5sum: string;
}

export interface PicInfo {
  /** 图片序列号。后台用于索引图片的键值。 */
  uuid: string;
  /** 图片格式。JPG = 1，GIF = 2，PNG = 3，BMP = 4，其他 = 255。 */
  imageFormat: im_api_message.ImageType;
  /** 原图、缩略图或者大图下载信息 */
  imageInfoArray: Array<ImageInfo>;
}

export interface FileInfo {
  /** 文件下载地址，可通过该 URL 地址直接下载相应文件。 */
  url: string;
  /** 文件数据大小，单位：字节。 */
  fileSize: string;
  /** 文件名称。 */
  fileName: string;
  /** 文件下载方式标记。目前 Download_Flag 取值只能为2，表示可通过Url字段值的 URL 地址直接下载文件。 */
  downloadFlag: number;
}

export interface AudioInfo {
  /** 语音下载地址，可通过该 URL 地址直接下载相应语音。 */
  url: string;
  /** 语音数据大小，单位：字节。 */
  size: string;
  /** 语音数据大小，单位：字节。 */
  second: string;
  /** 语音下载方式标记。目前 Download_Flag 取值只能为2，表示可通过Url字段值的 URL 地址直接下载语音。 */
  downloadFlag: string;
}

export const enum MsgType {
  MsgTypeUnknown = 0,
  MsgTypeCommon = 1,
  MsgTypeControl = 2,
}

export const enum MsgL2Type {
  MsgL2TypeUnknown = 0,
  MsgL2TypeText = 1,
  MsgL2TypeVideo = 2,
  MsgL2TypePic = 3,
  MsgL2TypeFile = 4,
  MsgL2TypeAudio = 5,
  MsgL2TypeSignaling = 6,
  MsgL2TypeRichText = 7,
  MsgL2TypeMarkdown = 8,
  MsgL2TypeCard = 9,
  MsgL2TypeSystem = 10,
  MsgL2TypeSticker = 11,
  MsgL2TypeMixed = 12,
  MsgL2TypeInteraction = 13,
  MsgL2TypeForward = 14,
  MsgL2TypeRoleCard = 15,
  MsgL2TypeGraffiti = 16,
  MsgL2TypeStructured = 17,
  MsgL2TypeTopicStructured = 18,
  MsgL2TypeCustomStructured = 19,
}

export const enum MsgL3Type {
  MsgL3TypeUnknown = 0,
  MsgL3TypeReply = 1,
  MsgL3TypeReaction = 2,
  MsgL3TypeAt = 3,
  MsgL3TypeInternalLink = 4,
  MsgL3TypeTopic = 5,
  MsgL3TypeContentLinkInfo = 6,
}

export const enum MsgSignalingType {
  MsgSignalingTypeUnknown = 0,
  MsgSignalingTypeGroupInfoChange = 1,
  MsgSignalingTypeChannelInfoChange = 2,
  MsgSignalingTypeGroupJoinMember = 3,
  MsgSignalingTypeGroupExitMember = 4,
  MsgSignalingTypeGroupExitMemberOnlyAdmin = 5,
  MsgSignalingTypeUserBan = 6,
  MsgSignalingTypeUserUnban = 7,
  MsgSignalingTypeChannelBan = 8,
  MsgSignalingTypeChannelUnban = 9,
  MsgSignalingTypInteractionChange = 10,
  MsgSignalingTypeGroupApplyTo = 11,
  MsgSignalingTypeDissolveGroup = 12,
  MsgSignalingTypeReactionMsg = 13,
  MsgSignalingTypeUpdateGroupNick = 14,
  MsgSignalingTypeApplyGroupOwner = 15,
  MsgSignalingTypeTopic = 16,
  MsgSignalingTypeH5UserRelationChange = 17,
  MsgSignalingTypeAdminRecall = 18,
  MsgSignalingTypePendant = 19,
  MsgSignalingTypeChanJoinMember = 20,
  MsgSignalingTypeChanExitMember = 21,
  MsgSignalingTypeChgRole = 22,
  MsgSignalingTypeGetAllMem = 23,
  MsgSignalingTypeBeginMigrateChannel = 24,
  MsgSignalingTypeFinishMigrateChannel = 25,
  MsgSignalingTypeCentreConfigChange = 26,
  MsgSignalingTypeChgRoleMsg = 27,
  MsgSignalingTypeChgRoleUserMemMsg = 28,
  MsgSignalingTypeModifyText = 29,
  MsgSignalingTypeModifyPic = 30,
  MsgSignalingTypeBan = 31,
  MsgSignalingTypeChannelBlockChange = 32,
}

export const enum MsgSignalingPriority {
  UnknownPriority = 0,
  LowPriority = 1,
  HighPriority = 2,
}

export const enum MsgStructuredType {
  MsgStructuredTypeUnknown = 0,
  MsgStructuredTypeMarkdown = 1,
  MsgStructuredTypeButton = 2,
}

export const enum MsgScope {
  MsgScopeUnknown = 0,
  MsgScopeC2C = 1,
  MsgScopeChannel = 2,
  MsgScopeGroup = 3,
  MsgScopeNotMsgInform = 100000000,
}

export const enum ChannelType {
  ChannelTypeUnknown = 0,
  ChannelTypeControl = 1,
  ChannelTypeCommon = 2,
}

export const enum AtType {
  AtTypeUnknown = 0,
  AtTypePartial = 1,
  AtTypeAll = 2,
  AtTypeRole = 3,
}

export const enum EmbedType {
  EmbedTypeUnknown = 0,
  EmbedTypeImage = 1,
  EmbedTypeWebPage = 2,
}

export const enum TagType {
  TagTypeUnknown = 0,
  TagTypeCreating = 1,
  TagTypeNormal = 2,
  TagTypeDelete = 3,
  TagTypeSystem = 4,
}

export const enum TagMsgType {
  TagMsgTypeUnknown = 0,
  TagMsgTypeNormal = 1,
  TagMsgTypeDelete = 2,
}

export const enum SearchListType {
  SearchListTypeUnknown = 0,
  SearchListTypeAll = 1,
  SearchListTypeSingle = 2,
}

export interface ReplyMsg {
  /** 被回复者uid */
  uidReplied: string;
  /** 被回复的消息内容,展示用 */
  content: string;
  /** 废弃 */
  msgKey: string;
  /** 被回复的消息唯一标识 */
  msgSeq: string;
  /** 消息id */
  msgId: string;
  /** 模板 */
  contentTemplate: string;
  /** 被回复的消息唯一标识(自研im) */
  messageId: string;
}

export interface AtMsg {
  /** @类型,部分@时候才需要填写at_uid_list */
  atType: AtType;
  /** 被@用户id列表 */
  atUidList: Array<string>;
}

export interface C2CMsg {
  /** 接受方uid */
  receiverUid: string;
  /** 消息唯一标识,回调补充,调用方不用填写 */
  messageKey: string;
  /** 消息序列号,用于标记该条消息,回复消息用,调用方不用填写 */
  msgSeq: string;
}

export interface ChannelMsg {
  /** channel id */
  channelId: string;
  /** 消息序列号,回调补充,调用方不用填写 */
  msgSeq: string;
  /** 群id */
  groupId: string;
  /** 前置回调校验值 */
  beforeSendChecksum: any;
}

export interface SignalingMsg {
  /** 信令消息 */
  signalingType: MsgSignalingType;
  /** 信令消息数据,根据MsgSignalingType决定使用对应结构体进行pb.Marshal */
  signalingData: any;
}

export interface CardInfoMsg {
  /** 链接 */
  link: string;
  /** 缩略图 */
  thumbnail: string;
  /** 标题 */
  title: string;
  /** 来源 */
  source: string;
  /** 扩展字段 */
  ext: Array<KvItem>;
}

export interface SystemMsg {
  /** 系统消息类型 */
  systemType: im_system.MsgSystemType;
  /** 系统消息数据,根据MsgSystemType决定使用对应结构体进行pb序列化 */
  systemData: any;
}

export interface StickerMsg {
  /** 表情id */
  stickerId: string;
  /** 表情包id */
  stickerPackageId: string;
  /** 表情包图片链接 */
  url: string;
  /** 图片宽度 */
  width: number;
  /** 图片高度 */
  height: number;
  /** 表情图md5 */
  md5sum: string;
  /** 原始图片链接 */
  origUrl: string;
}

export interface MixedMsgItem {
  /** 混合消息类型 */
  l2Type: MsgL2Type;
}

export interface MixedMsg {
  /** 混合消息 */
  msgItemList: Array<MixedMsgItem>;
}

export interface BotData {
  /** 机器人指令id */
  cmdId: string;
  /** 如果是机器人发的消息,此字段填true(可以直接用该字段判断是否机器人消息) */
  isBot: boolean;
}

export interface ForwardMsgExtendInfo {
  /** 群id */
  groupId: string;
  /** 群名称 */
  groupName: string;
  /** 群头像 */
  groupAvatar: string;
  /** 频道id */
  channelId: string;
  /** 频道名 */
  channelName: string;
  /** 跳转链接(返回展示用,发送转发消息无需填写) */
  jumpUrl: string;
  /** 用户是否入群,是为1,否为0(返回展示用,发送转发消息无需填写) */
  isJoined: number;
  /** 官方运营标签名字 */
  groupTagName: string;
  /** 官方运营标签类型 参考GrpOfficialTagType */
  groupTagType: number;
}

export interface ChannelForwardInfo {
  /** 频道id */
  channelId: string;
  /** 群聊转发消息点开消息后顶部展示 */
  msgExtendInfo: ForwardMsgExtendInfo;
}

export interface C2CForwardInfo {
  /** 单聊较小uid */
  uidMin: string;
  /** 单聊较大uid */
  uidMax: string;
}

export interface ForwardMsgItem {
  /** 唯一消息标识,群聊为{msg_seq},单聊为{uid}_{msg_seq} */
  uniqueMsgSeq: string;
  /** 版本号,主要对于编辑消息使用 */
  version: string;
  /** 消息id(自研使用) */
  messageId: string;
}

export interface ForwardMsgDisplayMsgItem {
  /** 用户昵称 */
  nickName: string;
  /** 消息摘要 */
  desc: string;
  /** 模板 */
  descTemplate: string;
}

export interface ForwardMsgDisplayInfo {
  /** 展示标题 */
  title: string;
  /** 展示消息列表,这里最多3条 */
  itemList: Array<ForwardMsgDisplayMsgItem>;
  /** 小尾巴 */
  tips: string;
}

export interface ForwardMsg {
  /** 被转发消息的范围,单聊/群聊 */
  scope: MsgScope;
  /** 群聊转发消息 */
  channelForwardInfo: ChannelForwardInfo;
  /** 单聊转发消息 */
  c2cForwardInfo: C2CForwardInfo;
  /** 消息数据列表 */
  itemList: Array<ForwardMsgItem>;
  /** 消息外显信息 */
  displayInfo: ForwardMsgDisplayInfo;
}

export interface RoleCardMsgItem {
  /** 角色卡数据 */
  roleCard: rolecard_srv.RoleCard;
}

export interface RoleCardMsg {
  /** 角色卡消息列表 */
  roleCardMsgList: Array<RoleCardMsgItem>;
}

export interface ReportParameters {
  /** 是否转发消息,多选不需要填,单条转发需要填 */
  isForwardMsg: boolean;
}

export interface GraffitiMsg {
  /** 图片数据 */
  picInfo: Array<PicInfo>;
}

export interface StructuredMsgItem {
  /** 结构化消息类型 */
  type: MsgStructuredType;
  /** 结构化markdown消息 */
  markdownMsg: StructuredMarkdownMsg;
  /** 结构化按钮消息 */
  buttonMsg: StructuredButtonMsg;
}

export interface StructuredMarkdownMsg {
  /** markdown内容 */
  content: string;
}

export const enum StructuredButtonType {
  StructuredButtonTypeDefault = 0,
}

export interface StructuredButtonMsg {
  /** 按钮类型 */
  type: StructuredButtonType;
  /** 按钮文案 */
  text: string;
  /** 按钮跳转链接 */
  url: string;
  /** 点击operid */
  clickOperId: string;
}

export interface StructuredMsg {
  /** 结构化消息布局(从上到下) */
  itemList: Array<StructuredMsgItem>;
}

export interface AggMsgInfo {
  /** 连续发多条需要用这个id标识 */
  aggMsgId: string;
  /** 连续发多条指明第几条 */
  aggMsgIdx: number;
  /** 连续发多条指明总条数 */
  aggMsgSize: number;
}

export interface InternalParameters {
  /** 是否不推送kafka消息,只在测试环境生效,默认推送 */
  notNeedPushKafka: boolean;
  /** 是否不推送给机器人,默认推送 */
  notNeedPushBot: boolean;
  /** 是否后台通过RESTAPI发送的消息 */
  isRestapiMsg: boolean;
  /** 是否不推送push消息,默认推送 */
  notNeedPushNotifation: boolean;
  /** 唯一id,用于发送方可重入发消息使用(自研使用) */
  sameMsgCheckInfo: any;
  /** 不需要计入未读数(默认为false,即计入,自研使用) */
  notNeedUnreadNum: boolean;
  /** 是否需要北极星限频(默认为false, 如果是自研im消息就为true) */
  isNeedPolarisLimit: boolean;
  /** 是否本地消息(只是终端使用) */
  isLocalMsg: boolean;
  /** 连续发多条消息信息 */
  aggMsgInfo: AggMsgInfo;
  /** 平台基础信息参数 */
  platformBasedInfoParams: PlatformBasedInfoParameters;
}

export interface PlatformBasedInfoParameters {
  /** 需要填充平台信息的用户列表 */
  uidsNeed: Array<string>;
}

export interface MsgTopicDataItem {
  /** 话题id */
  topicId: string;
  /** 话题名称 */
  topicName: string;
}

export interface MsgTopicData {
  /** 话题数据 */
  itemList: Array<MsgTopicDataItem>;
}

export const enum TopicStructuredMsgType {
  TopicStructuredMsgTypeUnknown = 0,
  TopicStructuredMsgTypeCreateTopic = 1,
  TopicStructuredMsgTypeMsgBindTopic = 2,
  TopicStructuredMsgTypeShare = 3,
}

export interface TopicStructuredMsg {
  /** 结构化消息上面的文字 */
  content: string;
  /** 话题ID */
  topicId: string;
  /** 话题名称 */
  topicName: string;
  /** 参与数 */
  joinCnt: string;
  /** 话题结构化消息类型 */
  type: TopicStructuredMsgType;
  /** 话题是否过期 */
  isExpire: boolean;
  /** 模板 */
  contentTemplate: string;
  /** 话题内容 */
  topicCont: string;
  /** 话题图片 */
  picUrls: Array<string>;
}

export interface CustomStructuredMsg {
  /** 发送自定义消息的bot_id */
  botId: string;
}

export interface BusinessPlatform {
  /** 发起渠道 */
  channel: external_login_common.ExternalChannel;
  /** 平台 */
  platform: common.Platform;
  /** 操作系统 */
  sysId: common.SystemType;
}

export interface MsgReceiveInfo {
  type: any;
  uidList: Array<string>;
}

export interface PlatformBasedUserInfo {
  avatar: string;
  nick: string;
}

export interface PlatformBasedInfoItem {
  userInfos: Record<string, PlatformBasedUserInfo>;
  templateInfos: Record<string, string>;
}

export interface PlatformBasedInfo {
  templatePlatformInfos: Record<number, PlatformBasedInfoItem>;
  defaultPlatformInfo: PlatformBasedInfoItem;
}

export interface MsgTemplateData {
  contentTemplate: string;
  descTemplate: string;
}

export interface ContentLinkBaseInfo {
  startPos: number;
  size: number;
  displayText: string;
}

export const enum ContentLinkInfoType {
  ContentLinkInfoTypeUnknown = 0,
  ContentLinkInfoTypeAt = 1,
  ContentLinkInfoTypeInternalLink = 2,
}

export interface AtV2MsgItem {
  atType: AtType;
  uid: string;
  roleId: string;
}

export interface InternalLinkMsgItem {
  type: string;
  ext: Record<string, string>;
}

export interface ContentLinkInfoItem {
  type: ContentLinkInfoType;
  contentLinkMsgInfo: ContentLinkBaseInfo;
  atV2MsgItem: AtV2MsgItem;
  internalLinkMsgItem: InternalLinkMsgItem;
}

export interface ContentLinkInfo {
  itemList: Array<ContentLinkInfoItem>;
}

export interface Msg {
  /** 普通消息/控制消息 */
  type: MsgType;
  /** 消息内容类型 */
  l2Type: MsgL2Type;
  /** 消息类型 */
  l3Types: Array<MsgL3Type>;
  /** 消息范围,单聊/channel/group */
  scope: MsgScope;
  /** 时间戳;注意,这里不能信任终端时间戳 */
  ts: string;
  /** 发送方uid */
  senderUid: string;
  /** 内容 */
  content: string;
  /** 视频数据 */
  videoInfo: Array<VideoInfo>;
  /** 图片数据 */
  picInfo: Array<PicInfo>;
  /** 文件数据 */
  fileInfo: Array<FileInfo>;
  /** 语音数据 */
  audioInfo: Array<AudioInfo>;
  /** 单聊消息结构 */
  c2cMsg: C2CMsg;
  /** channel消息结构 */
  channelMsg: ChannelMsg;
  /** 回复消息 */
  replyMsg: ReplyMsg;
  /** at消息 */
  atMsg: AtMsg;
  /** 信令消息 */
  signalingMsg: SignalingMsg;
  /** 消息摘要 */
  desc: string;
  /** 卡片消息 */
  cardInfo: Array<CardInfoMsg>;
  /** 系统消息 */
  systemMsg: SystemMsg;
  /** 表情消息 */
  stickerMsg: StickerMsg;
  /** 互动类消息 */
  interactionMsg: Array<im_interaction_message.InteractionMsg>;
  /** 混合消息,目前只用于存储顺序 */
  mixedMsg: MixedMsg;
  /** 机器人相关数据 */
  botData: BotData;
  /** 消息版本,编辑消息用 */
  version: string;
  /** 转发消息 */
  forwardMsg: ForwardMsg;
  /** 角色卡消息 */
  roleCardMsg: RoleCardMsg;
  /** 上报相关参数 */
  reportParams: ReportParameters;
  /** 涂鸦消息 */
  graffitiMsg: GraffitiMsg;
  /** 结构化消息 */
  structuredMsg: StructuredMsg;
  /** 内部参数 */
  internalParams: InternalParameters;
  /** 消息话题数据 */
  msgTopicData: MsgTopicData;
  /** 话题结构化消息 */
  topicStructuredMsg: TopicStructuredMsg;
  /** 自定义消息 */
  customMsg: CustomStructuredMsg;
  /** 业务平台信息 */
  busiPlatform: BusinessPlatform;
  /** 摘要相关数据,content和desc在外层 */
  templateData: MsgTemplateData;
  /** 平台基础信息 */
  platformBasedInfo: PlatformBasedInfo;
  /** 内容链接信息 */
  contentLinkMsg: ContentLinkInfo;
}

export interface MsgKKIM {
  msgData: any;
  msgStatus: any;
  sameMsgCheckInfo: any;
  messageId: string;
  notNeedUnreadNum: boolean;
  conversationId: string;
  ts: string;
  updateTs: string;
}

export interface MsgCommItem {
  /** 消息结构 */
  msg: Msg;
  /** 用户信息 */
  user: user_common.UserInfoBase;
}

export interface ImCallbackMsg {
  /** 腾讯云回调请求 */
  callbackReq: im_api_callback.ImCallbackReq;
  /** 消息体 */
  msg: Array<Msg>;
  /** url参数,SdkAppid,CallbackCommand,contenttype,ClientIP,OptPlatform */
  queryStr: Record<string, string>;
  /** 消息唯一id（自研） */
  messageId: string;
  /** 是否由自研im转换而得 */
  isSalmonMsg: boolean;
}

export interface KvItem {
  /** 自定义的 Key */
  key: string;
  /** 自定义字段值 */
  value: string;
}

export interface Member {
  /** 成员（必填），系统用户Uid */
  memberAccount: string;
  /** 赋予该成员的身份，目前备选项只有 Admin（选填） */
  role: string;
  /** 群成员维度自定义字段（选填） */
  appMemberDefinedData: Array<KvItem>;
  /** 加人结果：0-失败；1-成功；2-已经是群成员；3-等待被邀请者确认 */
  result: number;
  /** 0-不存在；1-存在 */
  inChannelStatus: number;
}

export const enum OnlineStatusChangeType {
  OnlineStatusChangeTypeUnknown = 0,
  OnlineStatusChangeTypeLogin = 1,
  OnlineStatusChangeTypeLogout = 2,
  OnlineStatusChangeTypeDisconnect = 3,
}

export const enum UserManualStatus {
  UserManualStatusUnknown = 0,
  UserManualStatusDoNotDisturb = 1,
}

export interface OnlineStatusItem {
  /** 平台 */
  platform: string;
  /** 在线状态变更类型 */
  onlineStatusChange: OnlineStatusChangeType;
  /** 变更时间 */
  changeTs: string;
  /** 在线状态 */
  onlineStatus: string;
}

export interface OnlineStatusChangeHistoryItem {
  /** 平台 */
  platform: string;
  /** 在线状态变更时间(存储最近2次) */
  onlineStatusChangeTs: Array<string>;
}

export interface OnlineStatusChangeHistory {
  /** 平台对应的状态变更列表 */
  platformItems: Record<string, OnlineStatusChangeHistoryItem>;
}

export interface OnlineStatusStorage {
  /** 用户id */
  uid: string;
  /** 平台对应的在线状态 */
  platformOnlineStatus: Record<string, OnlineStatusItem>;
  /** 缓存更新时间 */
  cacheUpdateTs: string;
  /** 拉取腾讯云接口的在线状态 */
  onlineStatus: string;
  /** 0默认是普通用户,1是机器人/官方号等非登录号的用户 */
  userType: number;
  /** 用户手动设置的状态 */
  userManualStatus: UserManualStatus;
  /** 在线状态变更历史(key为OnlineStatusChangeType) */
  onlineStatusChangeHistory: Record<number, OnlineStatusChangeHistory>;
}

export interface UserCheckChannelInfo {
  /** 频道id */
  channelId: string;
  /** 权限列表 */
  permsIds: Array<string>;
}

export interface UserCheckGroupInfo {
  /** 群id */
  groupId: string;
  /** 权限列表 */
  permsIds: Array<string>;
}

export interface C2CMsgSendStorage {
  /** msg_key列表 */
  msgKeyList: Array<string>;
  /** 不占用三次机会的msg_key列表 */
  notOccupyMsgKeyList: Array<string>;
}

export interface UserCheckC2CInfo {
  /** 接收者uid */
  receiverUid: string;
  /** 权限列表 */
  permsIds: Array<string>;
  /** 私聊消息发送存储(我发给接收者) */
  c2cMsgSendStorageToReceiver: C2CMsgSendStorage;
  /** 私聊消息发送存储cas(我发给接收者) */
  casToReceiver: number;
  /** 私聊消息发送存储(接收者发给我) */
  c2cMsgSendStorageFromReceiver: C2CMsgSendStorage;
  /** 私聊消息发送存储cas(接收者发给我) */
  casFromReceiver: number;
  /** 见BlockFlag,用于确定uid是否被receiver_uid设置黑名单 */
  blockFlag: number;
  /** 用户基础信息 */
  userInfo: user_common.UserInfoBase;
}

export interface UserCheckInfo {
  /** 用户id */
  uid: string;
  /** 频道维度校验信息 */
  userCheckChannelInfos: Record<string, UserCheckChannelInfo>;
  /** 群组维度校验信息 */
  userCheckGroupInfos: Record<string, UserCheckGroupInfo>;
  /** 单聊维度校验信息 */
  userCheckC2cInfos: Record<string, UserCheckC2CInfo>;
  /** 用户基础信息 */
  userInfo: user_common.UserInfoBase;
  /** 用户全局禁言信息 */
  globalBlockUserInfo: group_minor_comm.GlobalBlockUserInfo;
}

export interface MsgStreamComputing {
  /** 普通消息/控制消息 */
  type: MsgType;
  /** 消息内容类型 */
  l2Type: MsgL2Type;
  /** 消息类型 */
  l3Types: Array<MsgL3Type>;
  /** 消息范围,单聊/channel/group */
  scope: MsgScope;
  /** 时间戳;注意,这里不能信任终端时间戳 */
  ts: string;
  /** 发送方uid */
  senderUid: string;
  /** 频道id */
  channelId: string;
  /** 群id */
  groupId: string;
  /** 信令消息类型 */
  signalingMsgSignalingType: MsgSignalingType;
  /** 进入/退出成员列表 */
  signalingMsgGroupSignalingMsgMembers: Array<GroupMember>;
  /** 单聊消息接收人uid */
  c2cMsgReceiverUid: string;
  /** 用户类型 */
  userType: user_common.UserType;
  /** 角色列表 */
  roleIdList: Array<string>;
}

export const enum ImCollectorOptType {
  ImCollectorOptUnknown = 0,
  ImCollectorOptAdd = 1,
  ImCollectorOptDel = 2,
}

export interface SpiderVideoInfo {
  /** 播放地址 */
  playUrl: string;
  /** 视频缩略图地址 */
  picUrl: string;
  /** 视频时长 */
  videoSecond: number;
  /** 请求头 */
  headers: Record<string, string>;
  /** 视频有效截止时间，时间戳 */
  deadline: string;
  /** 视频标题 */
  title: string;
}

export const enum TextType {
  TextTypeUnknown = 0,
  TextTypePlain = 1,
  TextTypeHTML = 2,
}

export interface LinkMsgInfo {
  /** 标题 */
  title: string;
  /** 展示图片 */
  thumbnail: string;
  /** 摘要 */
  summary: string;
  /** 来源 */
  source: string;
  /** 来源icon */
  sourceIcon: string;
  /** 是否是视频 */
  isVideo: boolean;
  /** 视频信息 */
  videoInfo: SpiderVideoInfo;
  /** 返回状态 */
  ret: number;
  /** 返回信息 */
  msg: string;
}

export interface ImCollectorMsgItem {
  /** 消息结构 */
  msg: Msg;
  /** 操作时间 */
  time: string;
  /** 链接消息内容 */
  linkMsgInfos: Record<string, LinkMsgInfo>;
  /** group id 收藏消息使用 */
  gid: string;
  /** 用户信息 */
  user: user_common.UserInfoBase;
  /** 标签信息 */
  tagInfo: Array<ImTagESElem>;
}

export interface ImC2CConversationInfo {
  /** 会话开启方 */
  starter: string;
  /** 会话开启方的平台 */
  optPlatform: string;
}

export const enum GroupExitType {
  GroupExitTypeUnknown = 0,
  GroupExitTypeQuit = 1,
  GroupExitTypeKicked = 2,
}

export interface GroupMember {
  /** 群组用户id */
  uid: string;
  /** 群组退出类型 */
  exitType: GroupExitType;
  /** 群组用户昵称 */
  nickName: string;
}

export interface ImTagESElem {
  /** 标签id */
  tid: string;
  /** 群组id */
  gid: string;
  /** 频道id，兼容终端使用string */
  cid: string;
  /** 用户id */
  uid: string;
  /** 标签名 */
  name: string;
  /** 标签状态 */
  status: TagType;
  /** 创建时间 */
  createTime: string;
  /** 更新时间 */
  updateTime: string;
  /** 标签关联消息数 */
  tagUnionNum: string;
}

export interface ImMsgTagESElem {
  /** 群组id */
  gid: string;
  /** 频道id，兼容终端使用string */
  cid: string;
  /** 标签id */
  tid: string;
  /** 用户id */
  uid: string;
  /** 消息id */
  msgSeq: string;
  /** 消息标签状态 */
  status: TagMsgType;
  /** 创建时间 */
  createTime: string;
  /** 更新时间 */
  updateTime: string;
}

export const enum RecallType {
  NormalRecall = 0,
  AdminRecall = 1,
  PunishRecall = 2,
}

export interface SimpleMsg {
  /** 消息id */
  messageId: string;
  /** 消息更新时间,发送/撤回/删除/重新编辑 */
  updateTs: string;
}

export interface PlatformInfo {
  /** 登录的平台类型。可能的返回值有：iPhone, Android, Web, PC, iPad, Mac。 */
  platform: string;
  /** 该登录平台的状态 */
  status: OnlineStatusType;
}

export const enum OnlineStatusType {
  OnlineStatusTypeUnknown = 0,
  OnlineStatusTypeOnline = 1,
  OnlineStatusTypeOffline = 2,
  OnlineStatusTypeDoNotDisturb = 3,
}

export interface UserOnlineStatus {
  /** 返回的用户的 UserID */
  account: string;
  /** 用户状态 */
  status: OnlineStatusType;
  /** 详细的登录平台信息 */
  detail: Array<PlatformInfo>;
}

export const enum ImReactionOptType {
  ImReactionOptTypeUnknown = 0,
  ImReactionOptTypeAdd = 1,
  ImReactionOptTypeDel = 2,
}

export interface MsgIDGroup {
  /** 群组ID */
  GroupId: string;
  /** 消息唯一标识 */
  MsgSeq: number;
}

export interface MsgIDC2C {
  /** 消息发送者 UserID */
  From_Account: string;
  /** 消息发送者 UserID */
  To_Account: string;
  /** 消息序列号，用于标记该条消息（32位无符号整数） */
  MsgSeq: number;
  /** 消息的发送时间戳，单位为秒,单聊消息优先使用 MsgTime 进行排序，同一秒发送的消息则按 MsgSeq 排序，MsgSeq 值越大消息越靠后 */
  MsgTime: string;
}

export interface MsgIDForUIC {
  /** 回调命令 */
  CallbackCommand: string;
  /** 群聊消息ID */
  msgIDGroup: MsgIDGroup;
  /** C2C消息ID */
  msgIDC2C: MsgIDC2C;
}
